/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from } from "rxjs"
import { catchError, mergeMap } from "rxjs/operators"
import CONSTANTS from "../../assets/js/Constants"

// Lấy thông tin bảo trì của phương tiện
const GetAllCalendarByTime = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR.GET_ALL_CALENDAR_BY_TIME),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Load danh sách events calendar theo thời gian
            const response = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.CALENDAR.GET_ALL_CALENDAR_BY_TIME}?from_date=${action.payload.fromDate}&to_date=${action.payload.toDate}`
            )

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR.SET_ALL_CALENDAR_BY_TIME, response.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   GetAllCalendarByTime
}
